var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center","no-gutters":""}},[_c('v-col',{attrs:{"cols":"12","lg":"9"}},[_c('div',{staticClass:"shop-announce ql-editor",staticStyle:{"font-size":"13px","padding":"0"},domProps:{"innerHTML":_vm._s(_vm.html)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }